import { useLayout } from '@/layout/LayoutProvider';
import {
  getRebrandedRadioDirection,
  getRebrandedRadioLegendProps,
  getRebrandedRadioOnChange,
  getRebrandedRadioOptions
} from '@/shared/components/rebranded/Radio/utils';
import { Radio as OldRadio, Props as RadioProps } from '@storeblocks/radio';
import { RadioButtons, RadioButtonsProps } from '@storeblocks/radio-buttons';
import React from 'react';
import styled from 'styled-components';

const Radio = (props: RadioProps) => {
  const { isRebrand } = useLayout();
  const { name, direction, options, onChange, label, hint, value, disabled } =
    props;

  const rebrandedRadioProps: RadioButtonsProps = {
    disabled,
    groupName: name,
    direction: getRebrandedRadioDirection(direction),
    options: getRebrandedRadioOptions(options, value),
    onChange: getRebrandedRadioOnChange(onChange),
    legendProps: getRebrandedRadioLegendProps(label, hint)
  };

  return isRebrand ? (
    <StyledRadio {...rebrandedRadioProps} />
  ) : (
    <OldRadio {...props} />
  );
};

const StyledRadio = styled(RadioButtons)`
  .radioButtonsItems.column {
    gap: 0.75rem;

    .label {
      font-size: 16px;
    }
  }
`;

export default Radio;
